import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import PostScrapPage from './pages/PostScrapPage';
import BecomeCollectorPage from './pages/BecomeCollectorPage';
import WhatHappensPage from './pages/WhatHappensPage';
import FaqPage from './pages/FaqPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import CookiePreferencesPage from './pages/CookiePreferencesPage';
import ForHouseholdsPage from './pages/ForHouseholdsPage';
import ForBusinessPage from './pages/ForBusinessPage';
import HowItWorksPage from './pages/HowItWorksPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import KitchenFittersPage from './pages/KitchenFittersPage';
import PlumbersHeatingPage from './pages/PlumbersHeatingPage';
import ConstructionBuildingPage from './pages/ConstructionBuildingPage';
import GarageDoorsPage from './pages/GarageDoorsPage';
import HvacAirConditioningPage from './pages/HvacAirConditioningPage';
import VehicleGaragesPage from './pages/VehicleGaragesPage';
import FencingGatesPage from './pages/FencingGatesPage';
import JunkWasteRemovalPage from './pages/JunkWasteRemovalPage';
import PropertyManagementPage from './pages/PropertyManagementPage';
import GymFitnessPage from './pages/GymFitnessPage';
import ItemsWeTakePage from './pages/ItemsWeTakePage';
import ItemsWeDontTakePage from './pages/ItemsWeDontTakePage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <div className="App">
          <Header />
          <main className="page-main">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/post-scrap" element={<PostScrapPage />} />
              <Route path="/become-a-collector" element={<BecomeCollectorPage />} />
              <Route path="/for-households" element={<ForHouseholdsPage />} />
              <Route path="/for-business" element={<ForBusinessPage />} />
              <Route path="/kitchen-fitters" element={<KitchenFittersPage />} />
              <Route path="/plumbers-heating-engineers" element={<PlumbersHeatingPage />} />
              <Route path="/construction-building-companies" element={<ConstructionBuildingPage />} />
              <Route path="/garage-door-roller-shutter-companies" element={<GarageDoorsPage />} />
              <Route path="/hvac-air-conditioning-companies" element={<HvacAirConditioningPage />} />
              <Route path="/vehicle-garages-workshops" element={<VehicleGaragesPage />} />
              <Route path="/fencing-gate-installers" element={<FencingGatesPage />} />
              <Route path="/junk-waste-removal-companies" element={<JunkWasteRemovalPage />} />
              <Route path="/property-management-companies" element={<PropertyManagementPage />} />
              <Route path="/gym-fitness-equipments" element={<GymFitnessPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/items-we-take" element={<ItemsWeTakePage />} />
              <Route path="/items-we-dont-take" element={<ItemsWeDontTakePage />} />
              <Route path="/what-happens-to-your-scrap" element={<WhatHappensPage />} />
              <Route path="/what-happens-to-your-waste" element={<WhatHappensPage />} />
              <Route path="/faqs" element={<FaqPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/refund-policy" element={<RefundPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/cookie-preferences" element={<CookiePreferencesPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
